import * as recommendationsService from './recommendations.service'

export const getRecommendations = ({categories, tags, backers, userId}) => {
    return recommendationsService.getRecommendations({categories, tags, backers, userId})
        .then(res => res.data)
        .then(data => data.hits.hits)
}